import { twMerge } from 'tailwind-merge';
import { MultiSelectContext } from './MultiSelectContext';
import { MultiSelectDropdown } from './MultiSelectDropdown';
import { MultiSelectTrigger } from './MultiSelectTrigger';
import type { SelectProps } from './types';
import { useMultiSelectState } from './useMultiSelectState';

export type { BaseOption, SelectOption } from './types';

/**
 * A select dropdown component that supports both single and multi-select modes.
 * Supports search, either with a separate search input in the popover panel,
 * or in the trigger button. It supports icons, displaying up to 5 stacked icons
 * in multi-select mode for the selected options. Has basic keyboard support,
 * including holding down Shift to select multiple options concurrently.
 */
export function MultiSelect<T>(props: SelectProps<T>) {
  const { className, children } = props;
  const state = useMultiSelectState(props);

  return (
    <MultiSelectContext.Provider value={state}>
      <div className={twMerge('relative rounded', className)}>
        <MultiSelectTrigger />
        <MultiSelectDropdown>{children}</MultiSelectDropdown>
      </div>
    </MultiSelectContext.Provider>
  );
}
